import { backendUrl } from "../Router/constant";
import { normalizeAuthToken } from "../utils/authStorage";
import service from "./service";

const login = async (payload) => {
  return service.post("admin/signin", payload).then((response) => {
    return response;
  });
};

const vendorLogin = async (payload) => {
  return service.post("vendors/signin", payload).then((response) => response);
};

const vendorSignUp = async (payload) => {
  return service.post("vendors/signup", payload).then((response) => response);
};

const verifyVendorSignupOtp = async (payload) =>
  service.post("vendors/signup/verify-otp", payload);

const vendorForgotPassword = (payload) =>
  service.post("vendors/forgot-password", payload);

const vendorResetPassword = (token, payload) =>
  service.post(`vendors/reset-password/${encodeURIComponent(token)}`, payload);

const vendorChangePassword = async (payload) => {
  return service
    .put("vendors/change-password", payload)
    .then((response) => response);
};

const vendorProfile = async () => {
  return service.get("vendors/profile").then((response) => response);
};

const updateVendorProfile = async (payload) =>
  service.put("vendors/profile", payload);

const completeVendorProfile = async (payload) =>
  service.post("vendors/profile/complete", payload);

const previewVendorProfile = async (payload) =>
  service.post("vendors/profile/preview", payload);

const uploadVendorProfileImage = async (file) =>
  service.upload("uploads", file);
const clientLogin = async (payload) => {
  return service.post("clients/signin", payload).then((response) => response);
};

const clientGoogleLogin = async (payload) => {
  return service.post("clients/google-login", payload).then((response) => response);
};

const clientSignUp = async (payload) => {
  return service.post("clients/signup", payload).then((response) => response);
};

const clientProfile = async () => service.get("clients/profile");
const updateClientProfile = async (payload) => service.put("clients/profile", payload);
const uploadClientImage = async (file) => service.upload("uploads", file);

const verifyVendorToken = async (token = localStorage.getItem("authToken")) =>
  service.get("vendors/verify-token", {
    headers: token
      ? { Authorization: `Bearer ${normalizeAuthToken(token)}` }
      : {},
  });
const verifyClientToken = async (token = localStorage.getItem("authToken")) => {
  return service
    .get("clients/verify-token", {
      headers: token
        ? { Authorization: `Bearer ${normalizeAuthToken(token)}` }
        : {},
    })
    .then((response) => response);
};

const verifyToken = async (token = localStorage.getItem("authToken")) => {
  return service
    .get("admin/verify-token", {
      headers: token
        ? { Authorization: `Bearer ${normalizeAuthToken(token)}` }
        : {},
    })
    .then((response) => {
      return response;
    });
};

const logout = async () => {
  return service.post("admin/logout").then((response) => {
    return response;
  });
};

const clientLogout = async () => {
  return service.post("clients/logout").then((response) => response);
};

const profile = async () => {
  return service
    .get(`${backendUrl}/admin/profile`)
    .then((response) => response);
};

const updateProfile = async (payload) => {
  return service
    .put(`${backendUrl}/admin/profile`, payload)
    .then((response) => response);
};

const changePassword = async (payload) => {
  return service
    .put(`${backendUrl}/admin/change-password`, payload)
    .then((response) => response);
};

const uploadProfileImage = async (file) => {
  return service
    .upload(`${backendUrl}/uploads`, file)
    .then((response) => response);
};

const signUp = async (payload) => {
  return service.post(backendUrl + "/auth/signup", payload).then((response) => {
    return response;
  });
};

const authMe = async () => {
  return service.get(`${backendUrl}/auth/me`).then((response) => {
    return response;
  });
};

const editAuthMe = async (payload) => {
  return service.put(`${backendUrl}/auth/profile`, payload).then((response) => {
    return response;
  });
};

const planDetails = async (payload) => {
  return service.get(`${backendUrl}/plans`, payload).then((response) => {
    return response;
  });
};

export default {
  login,
  vendorLogin,
  vendorSignUp,
  verifyVendorSignupOtp,
  vendorForgotPassword,
  vendorResetPassword,
  vendorChangePassword,
  vendorProfile,
  updateVendorProfile,
  completeVendorProfile,
  previewVendorProfile,
  uploadVendorProfileImage,
  clientLogin,
  clientGoogleLogin,
  clientSignUp,
  clientProfile,
  updateClientProfile,
  uploadClientImage,
  verifyVendorToken,
  verifyClientToken,
  verifyToken,
  logout,
  clientLogout,
  profile,
  updateProfile,
  changePassword,
  uploadProfileImage,
  signUp,
  authMe,
  editAuthMe,
  planDetails,
};
